import { render, staticRenderFns } from "./irc.vue?vue&type=template&id=1aa6670a&scoped=true"
import script from "./irc.vue?vue&type=script&lang=js"
export * from "./irc.vue?vue&type=script&lang=js"
import style0 from "./irc.vue?vue&type=style&index=0&id=1aa6670a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6670a",
  null
  
)

export default component.exports